import getLabelTriggerWidth from 'src/js/modules/control-pane/helpers/get-label-trigger-width';
import { i18next } from '@yola/ws-sdk';

let cachedWidth = null;

const getCreateLayoutTriggerWidth = () => {
  const text = i18next.t('Create layout');

  if (!text) return 0;

  if (cachedWidth) {
    return cachedWidth;
  }

  const glyphSize = 18;
  const iconLeftMargin = 8;
  cachedWidth = getLabelTriggerWidth(text) + glyphSize + iconLeftMargin;

  return cachedWidth;
};

export default getCreateLayoutTriggerWidth;
